import React from "react";
import { Navigate } from "react-router-dom";

// Mock function to check if the user is logged in (replace with your actual authentication logic)
const isAuthenticated = () => {
  // Example: checking for an authentication token in local storage
  return localStorage.getItem("authToken") !== null;
};

const PrivateRoute = ({ element }) => {
  return isAuthenticated() ? element : <Navigate to="/" />;
};

export default PrivateRoute;
